// extracted by mini-css-extract-plugin
export default {"threeDotMenu":"EditTimesheetModal_threeDotMenu__zRqWW","actionsContainer":"EditTimesheetModal_actionsContainer__ch2sk"};